import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterPipeDeliberyNote'
})
export class FilterPipeDeliberyNote implements PipeTransform {
    transform(delibery_notes: any, term?: any): any {
        if (term === undefined) return delibery_notes;
        if (term === null) return delibery_notes;

        if (delibery_notes != null) {
            return delibery_notes.filter(function (delibery_note) {
                if (delibery_note.date != undefined)
                    if (delibery_note.date.toString().toLowerCase().includes(term.toLowerCase()))
                        return delibery_note;
                if (delibery_note.number != undefined)
                    if (delibery_note.number.toString().toLowerCase().includes(term.toLowerCase()))
                        return delibery_note;
                if (delibery_note.provider_static != undefined)
                    if (delibery_note.provider_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return delibery_note;

            })
        }



    }
}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-list/filter.pipe.ts